import TilesCrud from "./components/TilesCrud";

function App() {
  return <TilesCrud />;
}

export default App;